import Api from '@/services/Api'

const URL = 'cxc/cargo-serie/';

export default {

    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('pk' in params) {
            params.id = params.pk;
            return Api().put(url + params.pk + '/', params)
        }
        return Api().post(url, params)
    }
}